module.exports = __webpack_public_path__ + "img/metaanoi.f76fee42.jpg";